import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import useProtectedRoutes from 'src/hooks/useProtectedRoutes';
import useVersionCheck from 'src/hooks/useVersionCheck';
import { Dashboard, Login } from 'src/pages';
import { TAB_KEYS } from 'src/pages/CareOrchestration/constants';
import { getCareOrchestrationPath } from 'src/pages/CareOrchestration/helpers';

const ProviderHudHome = () => {
  const { search } = useLocation();
  return (
    <Navigate replace to={{ pathname: getCareOrchestrationPath(TAB_KEYS.PROVIDER_HUD), search }} />
  );
};

const AppRouter = () => {
  useVersionCheck();
  useProtectedRoutes();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/provider-hud" element={<ProviderHudHome />} />
      <Route path="/*" element={<Dashboard />} />
    </Routes>
  );
};

export default AppRouter;
